/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

const doesVariantHasOptionValue = (variant, option) => variant.option_values.find(rvOptionValue => rvOptionValue.ref_id === option.ref_id);

const calcVariantDistance = (variant1, variant2) => {
  const diff1 = variant1.option_values.filter(
    optionValue => !doesVariantHasOptionValue(variant2, optionValue),
  );
  const diff2 = variant1.option_values.filter(
    optionValue => !doesVariantHasOptionValue(variant2, optionValue),
  );

  if (!diff1 || !diff2) {
    return 0;
  }

  return Math.max(diff1.length, diff2.length);
};

export const getBestMatch = (selectedOption, activeVariant, variants) => {
  let bestMatch = activeVariant;
  let bestCost = 10000;
  const currentVariant = activeVariant;

  variants.forEach((variant) => {
    if (doesVariantHasOptionValue(variant, selectedOption)) {
      const newDiff = calcVariantDistance(currentVariant, variant);
      if (newDiff < bestCost) {
        bestCost = newDiff;
        bestMatch = variant;
      }
    }
  });

  return bestMatch;
};

export const isOptionSelectable = (selectedOption, activeVariant, variants) => {
  const hypotheticalVariantOptions = activeVariant.option_values.filter(
    optionValue => optionValue.option_type_id !== selectedOption.option_type_id,
  );
  hypotheticalVariantOptions.push(selectedOption);

  return _.some(variants, variant => _.every(variant.option_values, optionValue => hypotheticalVariantOptions.map(o => o.ref_id).includes(optionValue.ref_id)));
};

export const isOptionRendered = (selectedOption, variants) => _.some(variants, variant => _.some(variant.option_values, { ref_id: selectedOption.ref_id }));

export const isOptionTypeRendered = (optionType, variants) => _.some(optionType.option_values, option => isOptionRendered(option, variants));
